import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";

import Slider from "./Slider";

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "Shri. K. Abdul Hakeem, Head, WRID",
      "-",
      "Sri. T.P. Girish Kumar, S/E 'SE', RC (Central)",
      "",
      "",
      "Smt. Aloshree Choudhury (RS&GIS)",
      "Sri. K. Sai Santosh JRF (WR)",
    ],
    row2: [
      "",
      "",
      "Sri. K. Bharath Kumar Reddy, S/E 'SC', WRID, WRG",
      "",
      "",
      "",
      "",
    ],
  },
};
export default class HDProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "100%" }}>
              <div className="card-body">
                <ProjPeopleContent data={projTeam} width="80%" />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
